import { createSlice } from '@reduxjs/toolkit';
import { fetchAdminClientWebsiteDisplay } from './features';
import { fetchAdminClientWebsiteOrdersList } from './features';

export const adminClientWebsiteDetails = createSlice({
  name: 'adminClientWebsiteDetails',
  initialState: {
    formData: null,
    urlSite: '',
    websiteId: null,
    account: null,
    ordersList: [],
    isLoading: true,
    isError: true,
    isListLoading: true,
    isListError: true,
  },
  reducers: {
    setAdminClientUrlSiteForDisplay: (state, action) => {
      state.urlSite = action.payload;
    },
    setAdminClientWebsiteId: (state, action) => {
      state.websiteId = action.payload;
    },
    setAdminClientWebsiteAccount: (state, action) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminClientWebsiteDisplay.fulfilled, (state, { payload }) => {
        state.formData = payload;
        state.isLoading = false;
        state.isError = false;
      })
      .addCase(fetchAdminClientWebsiteDisplay.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchAdminClientWebsiteDisplay.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(fetchAdminClientWebsiteOrdersList.fulfilled, (state, { payload }) => {
        state.ordersList = payload;
        state.isListLoading = false;
        state.isListError = false;
      })
      .addCase(fetchAdminClientWebsiteOrdersList.pending, (state) => {
        state.isListLoading = true;
        state.isListError = false;
      })
      .addCase(fetchAdminClientWebsiteOrdersList.rejected, (state) => {
        state.isListLoading = false;
        state.isListError = true;
      });
  },
});

export default adminClientWebsiteDetails.reducer;

export const { 
  setAdminClientUrlSiteForDisplay, 
  setAdminClientWebsiteId, 
  setAdminClientWebsiteAccount 
} = adminClientWebsiteDetails.actions;

export const adminClientWebsiteDetailsSelector = (state) => state.adminClientWebsiteDetails;

